import { render, staticRenderFns } from "./ProtocolSmall.vue?vue&type=template&id=a0811c5a&"
import script from "./ProtocolSmall.vue?vue&type=script&lang=js&"
export * from "./ProtocolSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports